import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ActiveFabricSummary from 'components/consumer/ActiveFabricSummary';
import Placeholder from 'components/consumer/Placeholder';
const ProductCardOptionsUI = t0 => {
  const $ = _c(14);
  const {
    loading: t1,
    fabricSelectedOption,
    productOptions: t2
  } = t0;
  const loading = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const productOptions = t3;
  if (loading) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Placeholder type="rect" loading={true} style={{
        height: 16,
        width: 172
      }} />;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classNames("pt-4 flex md:flex-row md:items-center flex-col items-start", {});
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== fabricSelectedOption) {
    t5 = !!fabricSelectedOption && <ActiveFabricSummary selectedOption={fabricSelectedOption} size="xs" nameDataXc="ProductCardActiveFabric-name" />;
    $[4] = fabricSelectedOption;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== productOptions) {
    t6 = productOptions.map(_temp);
    $[6] = productOptions;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <div className="ProductCardOptionsUI__options">{t6}</div>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
ProductCardOptionsUI.propTypes = {
  fabricSelectedOption: PropTypes.object,
  loading: PropTypes.bool,
  productOptions: PropTypes.array
};
export default ProductCardOptionsUI;
function _temp(option) {
  return <div className="items-center flex pl-0.5 pb-1.5" key={option}><div className="bg-yellow-light rounded-sm h-3 mr-2.5 w-3" /><div className="text-xs text-gray flex font-bold">{option}</div></div>;
}